
import React from 'react';

interface FactorsListProps {
  factors: Array<{
    name: string;
    description: string;
    category: string;
    weight: number;
  }>;
}

const categoryLabels: Record<string, string> = {
  'sound_tricks': '🔊 Sound Tricks',
  'emotion_imagery': '💭 Emotion & Memory',
  'cognitive_grip': '🌀 Linguistic Structure'
};

const FactorsList: React.FC<FactorsListProps> = ({ factors }) => {
  // Group factors by category
  const groupedFactors = factors.reduce((groups, factor) => {
    const category = factor.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(factor);
    return groups;
  }, {} as Record<string, typeof factors>);
  
  // Get categories in a specific order
  const categories = ['sound_tricks', 'emotion_imagery', 'cognitive_grip'].filter(
    category => groupedFactors[category]?.length > 0
  );

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-2">Triggered Memorability Factors</h3>
      
      {factors.length === 0 ? (
        <p className="text-gray-500 italic">No memorability factors detected</p>
      ) : (
        <div className="space-y-4">
          {categories.map(category => (
            <div key={category} className="space-y-2">
              <h4 className="font-medium text-sm text-gray-700">
                {categoryLabels[category] || category}
              </h4>
              <ul className="space-y-2 pl-1">
                {groupedFactors[category].map((factor, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm">
                    <div className="bg-blue-100 text-blue-800 rounded-full px-1.5 py-0.5 text-xs font-semibold mt-0.5 min-w-[1.5rem] text-center">
                      +{factor.weight}
                    </div>
                    <div>
                      <div className="font-medium">{factor.name}</div>
                      <div className="text-gray-600 text-xs">{factor.description}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FactorsList;
